module.exports = __webpack_public_path__ + "static/media/smlogo.651ddb55.png";